export const mapApiKey = "AIzaSyAzqZ-jOFkKxUnxsYS4YRRneB_hujVsHKI";

export const config = {
  bucketName: "houzez--prod-storage",
  region: "ap-south-1",
  accessKeyId: "AKIAQWFMJ6YGXJHWA7TG",
  secretAccessKey: "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",
  dirName: "Houzez",
};

export const DetailImageCarouselsettings = {
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  className: "Carouselsettings  sportSlider",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 590,
      settings: {
        slidesToShow: 1,
        arrows: false,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        arrows: false,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        arrows: false,
      },
    },
  ],
};

export const bestLuxurySlider = {
  dots: false,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 5000,
  arrows: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  initialSlide: 0,
  className: "EventNewsSlider",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 2,
        infinite: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 590,
      settings: {
        slidesToShow: 2,
        arrows: false,
        infinite: false,
        autoplay: true,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        arrows: false,
        infinite: false,
        autoplay: true,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 2,
        arrows: false,
        infinite: false,
        autoplay: true,
      },
    },
  ],
};
export const FoodMenuSlider = {
  dots: false,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 5000,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  initialSlide: 0,
  className: "EventNewsSlider",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
        infinite: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 590,
      settings: {
        slidesToShow: 2,
        arrows: false,
        infinite: false,
        autoplay: true,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        arrows: false,
        infinite: false,
        autoplay: true,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        arrows: false,
        infinite: false,
        autoplay: true,
      },
    },
  ],
};

export const BoxSlider = {
  dots: false,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 5000,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,
  className: "EventNewsSlider",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
        infinite: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 590,
      settings: {
        slidesToShow: 2,
        arrows: false,
        infinite: false,
        autoplay: true,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        arrows: false,
        infinite: false,
        autoplay: true,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        arrows: false,
        infinite: false,
        autoplay: true,
      },
    },
  ],
};

export const HomeBannerSlider = {
  dots: false,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 5000,
  arrows: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  initialSlide: 0,
  className: "EventNewsSlider",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
        dots: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
        infinite: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 590,
      settings: {
        slidesToShow: 2,
        arrows: false,
        infinite: false,
        autoplay: true,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        arrows: false,
        infinite: false,
        autoplay: true,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        arrows: false,
        infinite: false,
        autoplay: true,
      },
    },
  ],
};

export const otherInspection = [
  {
    name: "Power",
    checked: false,
    iconUrl:
      "https://appsinvo-stag-dev.s3.ap-south-1.amazonaws.com/media-appsinvo-dev/houzez/2023/Jul/file_1689572733978.png",
  },
  {
    name: "Water",
    checked: false,
    iconUrl:
      "https://appsinvo-stag-dev.s3.ap-south-1.amazonaws.com/media-appsinvo-dev/houzez/2023/Jul/file_1689572788469.png",
  },
  {
    name: "Cleaning",
    checked: false,
    iconUrl:
      "https://appsinvo-stag-dev.s3.ap-south-1.amazonaws.com/media-appsinvo-dev/houzez/2023/Jul/file_1689572817049.png",
  },
  {
    name: "Key",
    checked: false,
    iconUrl:
      "https://appsinvo-stag-dev.s3.ap-south-1.amazonaws.com/media-appsinvo-dev/houzez/2023/Jul/file_1689572771018.png",
  },
  {
    name: "Gate pass",
    checked: false,
    iconUrl:
      "https://appsinvo-stag-dev.s3.ap-south-1.amazonaws.com/media-appsinvo-dev/houzez/2023/Jul/file_1689572705089.png",
  },
];
